<template>
  <Modal
    footer-hide
    v-model="chartScreenModal"
    width="90%">
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    </Spin>
    <div class="title" :style="{textAlign: 'center'}"><b><span id="chartScreenId_title" :style="{fontSize: '16px'}">{{ chartScreenTitle }}</span></b></div>
    <Form :model="graphScreenFilter" style="margin: 20px 0 0 0;" ref="graphScreenFilter" label-position="left" inline>
      <FormItem>
        <radio-group v-model="graphScreenFilter.last" type="button" size="small" @on-change="lastTimeChange">
          <radio label=3600>1小时</radio>
          <radio label=21600>6小时</radio>
          <radio label=43200>12小时</radio>
          <radio label=86400>1天</radio>
          <radio label=259200>3天</radio>
          <radio label=604800>7天</radio>
          <radio label=2592000>1月</radio>
        </radio-group>
      </FormItem>
      <FormItem>
        <DatePicker
          v-model="customTime"
          type="datetimerange"
          style="min-width: 250px;"
          format="yyyy-MM-dd HH:mm"
          @on-ok="customTimeChange"
          @on-clear="customTimeClear"
          placeholder="自定义时间"
          class="mob-w-100"></DatePicker>
      </FormItem>
      <FormItem>
        <Select v-model="graphScreenFilter.cf" placeholder="平均值" style="min-width: 100px;" :transfer="true" @on-change="getChartScreenData">
          <Option v-for="item in cf_list" :value="item.value" :key="item.value" :label="item.label"></Option>
        </Select>
      </FormItem>
      <FormItem label="求和" :label-width="45">
        <i-switch v-model="graphScreenFilter.sum" @on-change="getChartScreenData">
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
      <FormItem label="只求和" :label-width="60">
        <i-switch v-model="graphScreenFilter.sumonly" @on-change="getChartScreenData">
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
    </Form>
    <div :style="{height: '500px'}" id="chartScreenId"></div>
  </Modal>
</template>

<script>
import { getEndpointMonitorData, getMonitorConfig } from '@/api/monitor'
import eventVue from './event.js'
import echarts from './echarts-use.js'
import { valueTranUnit } from '@/libs/tools'

let ScreenOption = {
  title: {
    text: ''
  },
  grid: {
    x: 40,
    x2: 40,
    left: 60
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      dataView: {show: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {}
    },
    right: 15
  },
  tooltip: {
    trigger: 'axis',
    formatter: function (params) {
      let str = '<div>' + params[0].axisValueLabel + '</div>'
      for (let i = 0; i < params.length; i++) {
        let value = params[i].data[1]
        let reValue = valueTranUnit(value, 1, '')
        str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
          '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
      }
      return str
    }
  },
  // tooltip: {
  //   trigger: 'axis',
  //   formatter: function (params) {
  //     let str = '<div>' + params[0].axisValueLabel + '</div>'
  //     for (let i = 0; i < params.length; i++) {
  //       let value = params[i].data[1]
  //       let unit = ''
  //       if (value >= 1024 * 1024 * 1024) {
  //         value = (value / (1024 * 1024 * 1024)).toFixed(1)
  //         unit = ' (GB)'
  //       } else if (value >= 1024 * 1024) {
  //         value = (value / (1024 * 1024)).toFixed(1)
  //         unit = ' (MB)'
  //       } else if (value >= 1024) {
  //         value = (value / 1024).toFixed(1)
  //         unit = ' (kB)'
  //       }
  //       let reValue = value + unit
  //       str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
  //         '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
  //     }
  //     return str
  //   }
  // },
  legend: {
    x: 'center',
    y: 'bottom',
    type: 'scroll',
    width: '90%',
    icon: 'rect',
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 15
  },
  xAxis: {
    type: 'time',
    splitLine: {
      show: false
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true
    },
    axisLabel: {
      formatter: function (value) {
        return valueTranUnit(value, 0)
      }
    }
    // axisLabel: {
    //   formatter: function (value, index) {
    //     let unit = ''
    //     let isAbs = ''
    //     if (value < 0) {
    //       isAbs = '-'
    //       value = Math.abs(value)
    //     }
    //     if (value >= 1024 * 1024 * 1024) {
    //       value = (value / (1024 * 1024 * 1024)).toFixed(0)
    //       unit = ' GB'
    //     } else if (value >= 1024 * 1024) {
    //       value = (value / (1024 * 1024)).toFixed(0)
    //       unit = ' MB'
    //     } else if (value >= 1024) {
    //       value = (value / 1024).toFixed(0)
    //       unit = ' kB'
    //     }
    //     return isAbs + value + unit
    //   }
    // }
  },
  series: []
}

export default {
  name: 'chart-modal',
  data () {
    return {
      chartScreenModal: false,
      chartScreenTitle: '',
      graphScreenFilter: {},
      monitorTheme: 'dark',
      customTime: '',
      angle_list: [
        {
          value: 'endpoint',
          label: '设备视角'
        },
        {
          value: 'counter',
          label: '指标视角'
        },
        {
          value: 'merge',
          label: '组合视角'
        }
      ],
      cf_list: [
        {
          value: 'AVERAGE',
          label: '平均值'
        },
        {
          value: 'MAX',
          label: '最大值'
        },
        {
          value: 'MIN',
          label: '最小值'
        }
      ],
      loading: true
    }
  },
  created: function () {
    this.getTheme()
    this.openChartChartFun()
  },
  methods: {
    // 获取主题
    getTheme () {
      getMonitorConfig().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.monitorTheme = result.data.theme
        }
      })
    },
    // 获取监控图表数据
    getGraphData (reqData) {
      this.loading = true
      getEndpointMonitorData(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          let data = result.data.series
          let dseries = []
          let haveArea = false
          let monitorTheme = this.monitorTheme
          if (monitorTheme.endsWith('-line')) {
            monitorTheme = monitorTheme.split('-line')[0]
          } else {
            haveArea = true
          }
          for (let v in data) {
            let dSeriesConfig = {
              name: data[v].name,
              data: data[v].data,
              type: 'line',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1
                  }
                }
              }
            }
            if (haveArea) {
              dSeriesConfig.areaStyle = {
                opacity: 0.2
              }
            }
            dseries.push(dSeriesConfig)
          }
          ScreenOption.series = dseries
          let graphLine = echarts.init(document.getElementById('chartScreenId'), monitorTheme)
          window.addEventListener('resize', function () {
            graphLine.resize()
          })
          graphLine.clear()
          graphLine.setOption(ScreenOption, true)
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！',
            desc: result.msg
          })
        }
        this.loading = false
      }).catch(res => {
        this.loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取监控数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！服务器无响应'
          })
        }
      })
    },
    // 触发获取监控图表数据
    getChartScreenData () {
      this.getGraphData(this.graphScreenFilter)
    },
    // 打开监控图表
    openChartModal (data) {
      this.customTime = ''
      this.chartScreenTitle = data.title
      this.graphScreenFilter = data.req_data
      this.graphScreenFilter.last = data.req_data.last + ''
      this.chartScreenModal = true
      this.getGraphData(data.req_data)
    },
    // 组件间可调用函数 - 触发打开监控图表
    openChartChartFun () {
      eventVue.$on('openChartFun', (data) => {
        this.openChartModal(data)
      })
    },
    // 查看图表选中时间触发
    lastTimeChange () {
      this.customTime = ''
      this.graphScreenFilter.start = ''
      this.graphScreenFilter.end = ''
      this.getChartScreenData()
    },
    // 查看图表选中自定义时间触发
    customTimeChange () {
      let timeRange = [this.customTime[0].getTime() / 1000, this.customTime[1].getTime() / 1000]
      if (timeRange[0] && timeRange[1]) {
        this.graphScreenFilter.last = ''
        this.graphScreenFilter.start = timeRange[0]
        this.graphScreenFilter.end = timeRange[1]
        this.getGraphData(this.graphScreenFilter)
      } else {
        this.graphScreenFilter.last = '3600'
        this.graphScreenFilter.start = ''
        this.graphScreenFilter.end = ''
        this.getGraphData(this.graphScreenFilter)
      }
    },
    // 查看图表清空自定义时间触发
    customTimeClear () {
      this.graphScreenFilter.start = ''
      this.graphScreenFilter.end = ''
      this.graphScreenFilter.last = '3600'
      this.getGraphData(this.graphScreenFilter)
    }
  }
}
</script>

<style scoped>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
